import { IGetListYearGroupService } from "../../../../../abstractions/services/actions/IGetListYearGroupService";
import { serviceProvider } from "../../../../../comun/provider/ServiceProvider";
import { fx_createMonitoreoBrocaRequestEmpty } from "../../../../../modulos/monitoreo/broca/request/MonitoreoBrocaRequest";
import {
  fx_createMonitoreoBrocaGetSemanaGroupListByFincaIdService,
  MonitoreoBrocaSemanaGroup,
} from "../../../../../modulos/monitoreo/broca/services/MonitoreoBrocaGetSemanaGroupListByFincaIdService";
import { BaseSecondSidebarItemRender } from "../../../../base/sidebar/BaseSecondSidebarItemRender";
import { BaseSecondSidebarRender } from "../../../../base/sidebar/BaseSecondSidebarRender";
import { MonitoreoBrocaModalRender } from "../modal/MonitoreoBrocaModalRender";
import { MonitoreoBrocaSplitViewModalRender } from "../modal/MonitoreoBrocaSplitViewModalRender";
import { MonitoreoBrocaSemanaItemRender } from "../list/MonitoreoBrocaSemanaItemRender";

/** Segundo sidebar del módulo de Monitoreo Broca: semanas ISO de la finca
 *  activa agrupadas por año; al seleccionar una semana notifica sus registros
 *  (el mapa pinta esos lotes). Sin eliminar: el API no expone delete para este
 *  módulo. */
export class MonitoreoBrocaSecondSidebarRender extends BaseSecondSidebarRender<MonitoreoBrocaSemanaGroup> {
  /**
   * @param onBack    Acción del botón volver.
   * @param _onSemana Notifica la semana seleccionada.
   */
  constructor(
    onBack: () => void,
    private readonly _onSemana: (semana: MonitoreoBrocaSemanaGroup) => void,
  ) {
    super(onBack);
  }

  protected get title(): string {
    return "MONITOREO BROCA";
  }

  /** Monitoreos de la finca activa agrupados por año → semana ISO. */
  protected getYearGroupListService(): IGetListYearGroupService<MonitoreoBrocaSemanaGroup> {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return fx_createMonitoreoBrocaGetSemanaGroupListByFincaIdService(finca.id);
  }

  /** Item de semana (lotes monitoreados esa semana). */
  protected createItem(
    item: MonitoreoBrocaSemanaGroup,
  ): BaseSecondSidebarItemRender {
    return new MonitoreoBrocaSemanaItemRender(item, this._onSemana);
  }

  /** Botón +: abre el formulario de nuevo monitoreo de la finca activa. */
  protected onAdd(): void {
    new MonitoreoBrocaModalRender(fx_createMonitoreoBrocaRequestEmpty()).init();
  }

  /** Botón vista dividida: abre el modal con los dos mapas comparando semanas. */
  protected onSplitView(): void {
    new MonitoreoBrocaSplitViewModalRender().init();
  }
}
